import React from "react";
import { useFetch } from "@/lib/api";
import { PageHeader, Loading, SectionTitle } from "@/components/common";
import TokenTable from "@/components/TokenTable";
import { Zap } from "lucide-react";

export default function BreakoutRadar() {
  const { data, loading } = useFetch("/breakout", []);
  return (
    <div className="fade-in">
      <PageHeader
        icon={Zap}
        title="Breakout Radar"
        subtitle="Early momentum-surge detection: tokens where volume and unique-buyer acceleration are spiking together. Evidence, not a prediction."
      />
      <div className="pnut-card mb-4 p-4">
        <p className="text-xs leading-relaxed text-slate-400">
          <span className="font-semibold text-amber-400">Why these appear:</span> ranked by combined
          volume acceleration + buyer acceleration. A high position means unusual early activity was
          detected — it does <span className="text-slate-200">not</span> mean the token will rise.
          Always verify liquidity, organic activity and security before acting.
        </p>
      </div>
      <SectionTitle right={<span className="live-dot" />}>Live Surge Feed</SectionTitle>
      {loading || !data ? <Loading /> : <TokenTable tokens={data.data} />}
    </div>
  );
}
